import React, { Suspense } from 'react';

// Drop-in replacement for @loadable/component using React.lazy.
// @loadable/component uses require() internally which doesn't work with Vite.
export default function loadable(importFn) {
  const LazyComponent = React.lazy(importFn);

  const LoadableComponent = ({ fallback, ...props }) => (
    <Suspense fallback={fallback || null}>
      <LazyComponent {...props} />
    </Suspense>
  );

  return LoadableComponent;
}
